import { render, staticRenderFns } from "./ABMPage.vue?vue&type=template&id=1f0f2a1c&scoped=true&"
import script from "./ABMPage.vue?vue&type=script&lang=js&"
export * from "./ABMPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f2a1c",
  null
  
)

export default component.exports